import { ModalType, UiModal } from "@ui-monorepo/index";
import styles from "./closed-popup.module.css";
import { FC } from "react";
import { StoreMetadata, useStoreImages, ASSETS_URL } from "@commons-monorepo/index";

type ClosedPopupProps = {
  storeMetadata: StoreMetadata;
};

const ClosedPopup: FC<ClosedPopupProps> = ({ storeMetadata }) => {
  const { partnerProfilePicture } = useStoreImages(storeMetadata);

  return (
    <UiModal
      title={""}
      type={ModalType.DEFAULT}
      onClose={() => {}}
      showHeader={false}
      styles={{
        padding: "0 1rem"
      }}
      content={{
        styles: {
          backgroundColor: "transparent"
        }
      }}
      show={true}>

      <div className={styles.closedPopupContainer}>
        <picture>
          {storeMetadata.ownerId ===
          "b16ff7bb594ccb296192699429c252d908ce1837" ?
          <>
              <source
              srcSet={`${ASSETS_URL}/prod/assets/web/icons/closed-popup-desk.png`}
              media='(min-width: 1200px)' />

              <source
              srcSet={`${ASSETS_URL}/prod/assets/web/icons/closed-popup-desk.png`}
              media='(min-width: 800px)' />

              <img src={`${ASSETS_URL}/prod/assets/web/icons/closed-popup-mobile.png`} />
            </> :

          <>
              <img
              src={partnerProfilePicture}
              alt={storeMetadata?.enterpriseName}
              className={`${styles.logo}`}
              loading='lazy' />

              <img src={`${ASSETS_URL}/prod/assets/web/store-off-popup.webp`} />
            </>}

        </picture>
      </div>
    </UiModal>);

};

export default ClosedPopup;